import { useEffect } from "react";
import { MyFortAgentItem } from "@/api/types";
import {
  MyAgentActiveDetailDialog,
  MyAgentInactiveDetailDialog,
  PayFusdActivateDialog,
} from "@/components/modal/home";
import { useMyAgentsUiStore } from "@/store/useMyAgentsUiStore";

/**
 * 弹窗统一出口：全局只渲染 3 个 Dialog 实例。
 * 卡片只需调用 store action，不负责渲染任何弹窗。
 */
export function MyAgentsDialogsHost({ agents }: { agents: MyFortAgentItem[] }) {
  const {
    activeDetailAgentId,
    closeActiveDetail,
    inactiveDetailAgentId,
    closeInactiveDetail,
    payFusdAgentId,
    closePayFusd,
    resetAll,
  } = useMyAgentsUiStore();

  // agentId 对应的 agent 被移除时（如转让后列表刷新），自动关闭对应弹窗
  useEffect(() => {
    const ids = new Set(agents.map(a => a.agentId));
    if (activeDetailAgentId !== null && !ids.has(activeDetailAgentId))
      closeActiveDetail();
    if (inactiveDetailAgentId !== null && !ids.has(inactiveDetailAgentId))
      closeInactiveDetail();
    if (payFusdAgentId !== null && !ids.has(payFusdAgentId)) closePayFusd();
  }, [
    agents,
    activeDetailAgentId,
    inactiveDetailAgentId,
    payFusdAgentId,
    closeActiveDetail,
    closeInactiveDetail,
    closePayFusd,
  ]);

  // 组件卸载（离开页面）时关闭所有弹窗
  useEffect(() => () => resetAll(), [resetAll]);

  const activeAgent =
    agents.find(a => a.agentId === activeDetailAgentId) ?? null;
  const inactiveAgent =
    agents.find(a => a.agentId === inactiveDetailAgentId) ?? null;
  const payFusdAgent = agents.find(a => a.agentId === payFusdAgentId) ?? null;

  return (
    <>
      <MyAgentActiveDetailDialog
        key={activeDetailAgentId ?? "active"}
        agent={activeAgent}
        open={!!activeAgent}
        onClose={closeActiveDetail}
      />
      <MyAgentInactiveDetailDialog
        key={inactiveDetailAgentId ?? "inactive"}
        agent={inactiveAgent}
        open={!!inactiveAgent}
        onClose={closeInactiveDetail}
      />
      {payFusdAgent && (
        <PayFusdActivateDialog
          key={payFusdAgentId}
          agent={payFusdAgent}
          open
          onClose={closePayFusd}
        />
      )}
    </>
  );
}
